const _find = require('lodash/find');
const _some = require('lodash/some');
const SUBSCRIPTION_STATUS = require('./subscriptionStatus');
const SCOPES = require('./scopes');

const isAdmin = (user) =>
  user && _some(user.grants, (grant) => grant.scope === SCOPES.admin);
const isAuthor = (user) =>
  user && _some(user.grants, (grant) => grant.scope === SCOPES.author);
const isEditor = (user) =>
  user && _some(user.grants, (grant) => grant.scope === SCOPES.editor);
const isManager = (user) =>
  user && _some(user.grants, (grant) => grant.scope === SCOPES.manage);
const isSales = (user) =>
  user && _some(user.grants, (grant) => grant.scope === SCOPES.sales);
const isStaff = (user) =>
  user &&
  (isAdmin(user) || isAuthor(user) || isEditor(user) || isManager(user) || isSales(user));
const isSystem = (user) => user && user.email === 'justin@achievable.me';

const canAuthor = ({ user, product, content }) => {
  if (!user) {
    return false;
  }

  if (isSystem(user) || isAdmin(user)) {
    return true;
  }

  return _some(user.grants, (grant) => {
    if (grant.scope !== SCOPES.author) {
      return false;
    }

    if (grant.targetType !== 'product') {
      return false;
    }

    if (product) {
      return grant.targetUuid === product.uuid;
    }

    if (content) {
      return grant.targetUuid === content.productUuid;
    }

    return false;
  });
};

const canEdit = ({ user, product, content }) => {
  if (!user) {
    return false;
  }

  if (isSystem(user) || isAdmin(user)) {
    return true;
  }

  if (canAuthor({ user, product, content })) {
    return true;
  }

  return _some(user.grants, (grant) => {
    if (grant.scope !== SCOPES.editor) {
      return false;
    }

    if (grant.targetType !== 'product') {
      return false;
    }

    if (product) {
      return grant.targetUuid === product.uuid;
    }

    if (content) {
      return grant.targetUuid === content.productUuid;
    }

    return false;
  });
};

const canManage = ({ user, organization }) => {
  if (!user || !organization) {
    return false;
  }

  if (isSystem(user) || isAdmin(user)) {
    return true;
  }

  return _some(user.grants, (grant) => {
    if (grant.scope !== SCOPES.manage) {
      return false;
    }

    if (grant.targetType !== 'organization') {
      return false;
    }

    return grant.targetUuid === organization.uuid;
  });
};

const findActiveSubscription = ({ user, product }) => {
  if (!user) {
    return null;
  }

  const { subscriptions } = user;

  const activeSubscription = _find(
    subscriptions,
    (subscription) =>
      subscription.productUuid === product.uuid &&
      subscription.status === SUBSCRIPTION_STATUS.full
  );

  return activeSubscription;
};

const hasFullAccess = ({ user, product }) => {
  return (
    findActiveSubscription({ user, product }) ||
    isManager({ user, product }) ||
    canAuthor({ user, product })
  );
};

module.exports = {
  canAuthor,
  canEdit,
  canManage,
  findActiveSubscription,
  hasFullAccess,
  isAdmin,
  isAuthor,
  isEditor,
  isSales,
  isStaff,
  isSystem,
  isManager,
};
